import { CollectionType } from 'app/queries/collections/collection-fragment'
import {
  createCollectionQuery,
  PaginatedCollection,
  typeToName,
} from 'app/queries/collections/single'
import { useStores } from 'app/store'
import { useEffect, useMemo } from 'react'
import usePagination from 'app/hooks/use-pagination'

export default function useCollectionPage(type: CollectionType, slug: string) {
  const { lastCollectionStore } = useStores()

  const collectionQuery = useMemo(() => createCollectionQuery(type), [type])

  const variables = useMemo(() => {
    return { [typeToName(type)]: slug }
  }, [slug])

  const pagination = usePagination(collectionQuery.query, variables, {
    limit: 12,
    formatFn: collectionQuery.mapToPage,
  })

  const { collection, featured } = (pagination?.data ||
    {}) as PaginatedCollection

  useEffect(() => {
    if (collection && lastCollectionStore) {
      lastCollectionStore.setCollectionId(collection.id)
      lastCollectionStore.setCollectionType(type)
      lastCollectionStore.setCollectionSlug(slug)
      lastCollectionStore.setCollectionName(collection.title)
      lastCollectionStore.setIsPrimaryCollection(false)
    }
  }, [collection, type, slug, lastCollectionStore])

  return { collection, featured, pagination }
}
